"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "IsPreloadedContext", {
    enumerable: true,
    get: function() {
        return IsPreloadedContext;
    }
});
function _react() {
    const data = require("react");
    _react = function() {
        return data;
    };
    return data;
}
const IsPreloadedContext = (0, _react().createContext)(false);

//# sourceMappingURL=IsPreloadedContext.js.map
